import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'

import { IDataProviderFilter, IFilter, Logic, Operator } from 'core-components/types'

import { getVersionCrud } from './getVersionCrud'

interface IGetPrevEltVersion {
  partnerId: string | null
  groupId: number | null
  eltType: EltType
}
export const getPrevEltVersion = async ({
  partnerId,
  eltType,
  groupId,
}: IGetPrevEltVersion): Promise<IELTData | null> => {
  const crud = getVersionCrud('getPrevEltVersion')
  crud.setSort({ field: 'EntryId', dir: 'desc' })
  crud.setPaging({ pageSize: 1, page: 0 })
  const filters: (IFilter | IDataProviderFilter)[] = [
    {
      field: 'EltType',
      value: eltType,
      operator: Operator.EQUAL,
    },
  ]

  if (partnerId) {
    filters.push({
      field: 'PartnerId',
      value: partnerId,
      operator: Operator.EQUAL,
    })
  }

  if (groupId) {
    filters.push({
      field: 'GroupId',
      value: groupId,
      operator: Operator.EQUAL,
    })
  }

  crud.setFilter({
    logic: Logic.AND,
    filters: filters,
  })

  const res = await crud.fetch({ force: true })
  return res?.items[0] || null
}
